// Add your custom JS here.

jQuery(document).ready(function($) {
/* When the user clicks on the button, 
toggle between hiding and showing the dropdown content */
function myFunction() {
  document.getElementById("myDropdown").classList.toggle("show");
}

// Close the dropdown if the user clicks outside of it
window.onclick = function(event) {
  if (!event.target.matches('.dropbtn')) {
	var dropdowns = document.getElementsByClassName("dropdown-content");
	var i;
	for (i = 0; i < dropdowns.length; i++) {
	  var openDropdown = dropdowns[i];
	  if (openDropdown.classList.contains('show')) {
		openDropdown.classList.remove('show');
	  }
	}
  }
}

});


// PAGE IMAGE SLIDER
jQuery(document).ready(function($) {
	$('.page-image-slider').each(function (index, sliderWrap) {
		var $slider = $(sliderWrap).find('.slider');
		$slider.slick({
			dots: true,
			adaptiveHeight: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
		});
	});
});

jQuery(document).ready(function($) {
	$('.testimonial-slider').each(function (index, sliderWrap) {
		var $slider = $(sliderWrap).find('.slider');
		$slider.slick({
			dots: true,
			arrows: true,
			adaptiveHeight: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			autoplay: true,
			fade: true,
			autoplaySpeed: 6000,
			useAutoplayToggleButton: false,
		});
	});
});

jQuery(document).ready(function($) {
	$(window).on('load', function () {
	  AOS.refresh();
	});
	$(function () {
	  AOS.init();
	});
});



jQuery(document).ready(function($) {
/* Embedded Videos */
var $embedded_videos = $('.gen-cont iframe');
$embedded_videos.each(function(e) {
	var $this = $(this),
		attr = $this.attr('src');
	console.log(attr);
	if ( attr.indexOf( 'youtu' ) !== -1 || attr.indexOf( 'vimeo' ) !== -1 ) {
		$this.wrap('<div class="video-wrapper"></div>');
	}
});
});


jQuery(document).ready(function($) {
$(window).scroll(function() {
	if ($(this).scrollTop() > 1){  
		$('.a-header').addClass("sticky");
	}
	else{
		$('.a-header').removeClass("sticky");
	}
});
});
